import Vue from 'vue'

const state = {
    // 
}

const getters = {
    // 
}

const actions = {
    workshopRequest: async ({commit}, queries) => {
        let url = `/api/workshops/${queries.id}`;

        if (queries.with) {
            let params = '?'
            queries.with.forEach((w, i) => params += (i > 0 ? '&' : '')+'with['+i+']='+w)
            url += params
        }

        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    workshopsRequest: async ({commit, dispatch}, queries) => {
        //remove null values
        queries = Object.entries(queries).reduce((a,[k,v]) => (v ? {...a, [k]:v} : a), {})
        //build query url
        // let url = '/api/workshops?'+Object.entries(queries).map(e => e.join('=')).join('&')
        let url = '/api/workshops?'+Object.entries(queries).map((e) => {
            if (typeof e[1] == 'object') {
                let s = ''
                e[1].forEach((q, i) => s += e[0]+'['+i+']='+q+(i<e[1].length-1 ? '&' : ''))
                return s
            }
            return e.join('=')
        }).join('&')

        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    workshopEditRequest: async ({commit}, queries) => {
        let url = `/api/workshops/${queries.id}`;

        return new Promise((resolve, reject) => {
            Vue.axios.put(url, queries.datas)
                .then(result => {
                    resolve(result.data.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    workshopCreateRequest: async ({commit}, queries) => {
        let url = `/api/workshops`;

        return new Promise((resolve, reject) => {
            Vue.axios.post(url, queries)
                .then(result => {
                    resolve(result.data.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    workshopDeleteRequest: async ({commit}, queries) => {
        let url = `/api/workshops/${queries.id}`;

        return new Promise((resolve, reject) => {
            Vue.axios.delete(url)
                .then(result => {
                    resolve(result)
                })
                .catch(err => {
                     if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    attachmentDownloadRequest: async ({commit}, queries) => {
        let url = `/api/attachments/${queries.id}/download`;
        
        // Ajouter meeting_id en paramètre si fourni
        const params = {};
        if (queries.meeting_id) {
            params.meeting_id = queries.meeting_id;
        }

        return new Promise((resolve, reject) => {
            Vue.axios.get(url, {
                responseType: 'blob',
                params: params
            })
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    workshopsSequencesRequest: async ({commit}, queries = {}) => {
        // remove null/undefined values
        queries = Object.entries(queries).reduce((a,[k,v]) => (v !== undefined && v !== null ? {...a, [k]:v} : a), {})
        let url = '/api/workshops/sequences';
        const params = Object.entries(queries).map(e => e.join('=')).join('&');
        if (params) {
            url += '?' + params;
        }
        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
}

const mutations = {
    // 
}

export default {
    state,
    getters,
    actions,
    mutations,
}